export default __webpack_public_path__ + "images/category_all_icon.png";